import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FaUsers, FaUserCheck, FaUserClock, FaBell } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const StatCard = ({ title, value, icon: Icon, color, percentage, loading, onClick }) => {
  return (
    <Card 
      className={`stat-card ${color} border-0 shadow-sm h-100`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer', transition: 'all 0.25s ease-in-out' } : {}}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1) !important';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
    >
      <Card.Body className="p-3">
        <div className="d-flex justify-content-between align-items-start">
          <div className="pe-1 overflow-hidden">
            <p className="text-muted mb-1 text-uppercase fw-bold text-truncate" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>{title}</p>
            <h3 className="mb-0 fw-bold text-dark fs-4 fs-md-3">
              {loading ? '...' : value}
            </h3>
            {percentage !== undefined && (
              <div className="mt-1 text-success fw-semibold text-truncate" style={{ fontSize: '0.72rem' }}>
                 +{percentage}% <span className="text-muted ms-1 fw-normal d-none d-sm-inline">since last month</span>
              </div>
            )}
          </div>
          <div className={`stat-icon bg-${color} bg-opacity-10 p-2 p-md-3 rounded-3 shadow-sm flex-shrink-0`}>
            <Icon className={`text-${color}`} size={18} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

const QuickStatsRow = ({ stats, loading }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const userRole = user?.role || 'employee';

  const handlePendingApprovalsClick = () => {
    let targetPath = '/wrms/approvals';
    if (userRole === 'admin') {
      targetPath = '/leaves';
    } else if (userRole === 'hr') {
      targetPath = '/wrms/admin';
    }
    navigate(targetPath);
  };

  return (
    <Row className="g-2 g-md-3">
      <Col xs={6} md={3}>
        <StatCard
          title="Total Employees"
          value={stats?.totalEmployees || 0}
          icon={FaUsers}
          color="primary"
          loading={loading}
          onClick={() => navigate('/employees')}
        />
      </Col>
      <Col xs={6} md={3}>
        <StatCard
          title="Present Today"
          value={stats?.presentToday || 0}
          icon={FaUserCheck}
          color="success"
          percentage={stats?.attendancePercentage}
          loading={loading}
          onClick={() => navigate('/attendance')}
        />
      </Col>
      <Col xs={6} md={3}>
        <StatCard
          title="On Leave"
          value={stats?.onLeave || 0}
          icon={FaUserClock}
          color="warning"
          loading={loading}
          onClick={() => navigate('/leaves')}
        />
      </Col>
      <Col xs={6} md={3}>
        <StatCard
          title="Pending Approvals"
          value={stats?.pendingApprovals || 0}
          icon={FaBell}
          color="danger"
          loading={loading}
          onClick={handlePendingApprovalsClick}
        />
      </Col>
    </Row>
  );
};

export default QuickStatsRow;
